const RentmanNewQuote = (
    {
        setNewQuote
    }
) => {

    const handleClick = () => { setNewQuote(true); }
    return (
        <div
            className="RentmanButton RentmanNew"
            onClick={handleClick}
        >
            +
        </div>
    );
}

export default RentmanNewQuote;